module.exports = __webpack_public_path__ + "static/media/PA_Systems.7422e73c.png";